<label class="label-basic__text">
  <div class="label-basic__content product-switch-label__content">
    The current product type is
    <span class="product-switch-label__content__product-type">{{ productType }} Life Insurance</span>.
  </div>
</label>

<button
  cp-button
  theme="blue-alt"
  variant="primary"
  size="large"
  class="product-switch-btn"
  [disabled]="isDisabled"
  (click)="showProductSwitchModal()"
>
  Change Product Type
</button>
